import { useState } from "react";
import animCoding from '../lotties/124016-coding-time';
import Lottie from 'react-lottie';
import Fade from 'react-reveal';

export default function Skill(props){

    const [tabSelected, setTabSelected] = useState('Programming')

    const animCodingOptions = {
        loop: true,
        autoplay: true,
        animationData: animCoding,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };

    // const Skills = (props) => {
    //     return (<>
    //         <tbody>
    //             <tr>
    //             <td className="text-md text-slate-500 font-light min-w-[100px]">{props.name}</td>
    //             <td className="w-full px-4">
    //                 <div className="rounded-full w-full h-2 bg-slate-100 border border-slate-300 border-solid">
    //                     <div style={{width: props.percentage}} className="rounded-full h-full bg-slate-300 border border-slate-300 border-solid"></div>
    //                 </div>
    //             </td>
    //             </tr>
    //         </tbody>

    //     </>)
    // }

    const Tabs = (props) => {
        return (
            <>
            <div style={{backgroundColor: (tabSelected !== props.tabName) ? 'rgba(241, 245, 249, .5)' : 'white', color: (tabSelected === props.tabName) ? 'rgb(71 85 105)' : 'rgb(100 116 139)',
        borderTopRightRadius: (props.isEnd) ? 10 : 0, borderRightWidth: (props.isEnd) ? 1 : 0    
        }} className="text-slate-500 font-semibold hover:cursor-pointer py-3 px-3 sm:px-5 bg-slate-50 border-slate-200 border border-spacing-3 border-b-0 inline-block" onClick={(s) => {
                setTabSelected(props.tabName)
            }} >{props.tabName}</div>
            </>
        )
    }

    const TabContent = () => {
        if(tabSelected === "Programming"){
            return (<>
                {/* <table class="table-auto">
                    <Skills name="Flutter" percentage="75%" />
                    <Skills name="Android" percentage="65%" />
                    <Skills name="Unity3D" percentage="50%" />
                </table> */}
                <p className="text-sm lg:text-md font-extralight mt-4 text-slate-800">
                I am a mobile developer with over 10+ years of experience and have already published apps, some of which have surpassed 100k downloads on the  <a href="https://play.google.com/store/apps/dev?id=8152103288885796153" className="text-blue-500">Google Play</a>. I specialize in developing applications for various industries, including health, law enforcement, coal-mining, investments, and marketplaces.
                <br/><br/>
                Over the past 3 years, I have extensively utilized Spring Boot to create a wide range of services for a telecommunications company. Notably, I have a proven track record of building high-performance services, such as an SMS broadcast system capable of handling 1000 transactions per second using Spring Boot.
                </p>
            </>)
        }else if(tabSelected === "Tools"){
            return (<>
                {/* <table class="table-auto">
                <Skills name="Springboot"  percentage="65%" />
                <Skills name="NodeJS"  percentage="30%" />
                <Skills name="Golang"  percentage="30%" />
                </table> */}
                <p className="text-sm lg:text-md font-extralight mt-4 text-slate-800">
                Some of the tools I use as a mobile developer include VSCode (Flutter), Android Studio (Android Native), XCode (Swift), and Unity3d (Mobile Game development). I also utilize Figma for UI/UX design and slicing, creating simple animations to be converted into Lottie format (as seen on this website), and Adobe Illustrator for vector graphics design.
                <br/><br/>
                As a backend developer, I rely on Intellij (Java Spring Boot) for development, Postman for API requests, MySQL Workbench for database design, JMeter for Stress Test, and Docker for containerization.
                </p>
            </>)
        }else{
            return (<>
                {/* <table class="table-auto">
                <Skills name="React"  percentage="50%" />
                <Skills name="Figma"  percentage="50%" />
                <Skills name="Illustrator"  percentage="75%" />
                </table> */}
                <p className="text-sm lg:text-md font-extralight mt-4 text-slate-800">
                Throughout my journey in the IT world, I have been actively involved in various activities. During my college years, I participated in national competitions. I have documented some of these experiences on my  <a href="http://yusuf-fachroni.blogspot.com/search/label/My%20Story" className="text-blue-500"> Blog </a>.
                <br/><br/>
                In addition to participating in competitions, I have also founded a startup called PaperPlay Studio, focusing on developing educational and productivity applications. The startup has been featured multiple times in online media outlets such as <a href="https://id.techinasia.com/paperplay-studio-asal-universitas-muhammadiyah-malang" className="text-blue-500"> Tech In Asia, </a> <a href="https://tekno.tempo.co/read/651102/ongkir-aplikasi-penghitung-tarif-kirim-paket" className="text-blue-500"> Tempo, </a> and <a href="https://codepolitan.com/blog/mudahkan-anak-belajar-mengaji-dengan-fun-educational-apps-belajar-al-quran" className="text-blue-500"> Codepolitan </a>. Furthermore, I allocate my time as a freelance worker on <a href="https://www.upwork.com/freelancers/~01843dd182dd292047" className="text-blue-500"> Upwork </a>, gaining valuable experience in multinational company settings.
                </p>
            </>)
        }
    }

    const Content = () => (
        <div className="sm:my-28 pr-10 pl-10">
            <h2 className="text-4xl sm:text-6xl lg:text-6xl font-semibold bg-gradient-to-r from-blue-900 to-teal-600 bg-clip-text text-transparent inline-block">My Skills</h2>
            <div className="tab-bg mt-10">
                <Tabs tabName="Programming" />
                <Tabs tabName="Soft Skills"  />
                <Tabs tabName="Tools" isEnd={true} />
            </div>
            <div className="p-4 border w-full h-[20rem] sm:h-96 lg:h-72 border-slate-200 border-solid rounded-tr-xl">
                <TabContent />
            </div>
            
        </div>
    )

    return (<>
            <section className="grid sm:grid-cols-2 w-full py-3 md:py-10" id="skill" ref={props.refs} aria-label="Skills">
                <div className="p-3 md:p-10 my-auto">
                    
                    <Fade left>
                        {/* <a href="https://lottiefiles.com/124016-coding-time">  */}
                            <Lottie 
                            options={animCodingOptions}
                            height={'100%'}
                            width={'100%'}
                        />
                        {/* </a> */}
                    </Fade>
                    {/* <img src="./assets/124016-coding-time.gif" className="my-auto" alt="" /> */}
                    {/* <iframe src="https://embed.lottiefiles.com/animation/124016" style={{width:'100%', height:'100%'}} title="lottie_programmer"></iframe> */}
                </div>
                <Fade right>
                    <Content />
                </Fade>
            </section>
    </>)
}